<template>
	<ion-page>
		<spot-header :title="pageTitle" :canGoHome="true" :showLogo="false" @pressedGoHome="$router.push('/home')"></spot-header>
		<ion-content :fullscreen="true">
			<ion-item v-if="!isActive">
				<ion-spinner name="lines" color="primary"></ion-spinner>
				<ion-label color="primary">{{ spinnerText}}</ion-label>
			</ion-item>
			<div id="actionArea" v-else>
				<div id="fieldsContainer"> <!--v-if="isActive"-->
					<div v-if="currField.id == field.movement_type">
						<spot-select
							:ref="currField.name"
							:label="currField.text"
							:allignLabel="currField.allignLabel"
							:required="currField.required"
							:placeholder="getPlaceHolder()"
							:enabled="!isClosed"
							:value="currField.value"
							:options="privateData.movement_types"
							:optionField="currField.refField"
							:canAddItem="currField.canAddItem"
							:canRefreshList="currField.canRefresh"
							:canUnlock="currField.canUnlock"
							selectedLabel="Selezionato"
							deselectLabel="rimuovi"
							selectLabel="seleziona"
							@selected="detectSelection"
							@unselected="detectUnselection">
						</spot-select>
					</div>
					<div v-if="currField.id == field.movement_package">
						<spot-select
							:ref="currField.name"
							:label="currField.text"
							:allignLabel="currField.allignLabel"
							:required="currField.required"
							:placeholder="getPlaceHolder()"
							:enabled="!isClosed"
							:value="currField.value"
							:options="privateData.movement_packages"
							:optionField="currField.refField"
							:canAddItem="currField.canAddItem"
							:canRefreshList="currField.canRefresh"
							:canUnlock="currField.canUnlock"
							selectedLabel="Selezionato"
							deselectLabel="rimuovi"
							selectLabel="seleziona"
							@selected="detectSelection"
							@unselected="detectUnselection">
						</spot-select>
					</div>
					<div v-if="currField.id == field.movement_header"> <!-- && settings.insert.autoSave == false -->
						<div class="items-label">
							<ion-label>{{ currField.text }}</ion-label>
							<span v-if="currField.required">*</span>
						</div>
						<div class="items-data">
							<ion-button fill="outline" size="default" @click="createAndPrint()">
								{{ !currField.value ? (canPrint ? labelSave + labelAnd + labelPrint : labelSave) : (canPrint ? labelReprint : null) }}
								<ion-icon v-if="!currField.value" slot="icon-only" :icon="save" size="large"></ion-icon>
								<ion-icon v-if="canPrint" slot="icon-only" :icon="print" size="large"></ion-icon>
							</ion-button>
						</div>
					</div>
				</div>
				<div id="actionsContainer">
					<spot-button
						v-if="isVisibleButton(currField.canGoBack)"
						fill="clear"
						size="large"
						color="primary"
						icon="chevronBackCircleOutline"
						:enabled="currField.canGoBack && !fields.list[field.movement_header].value"
						:expand="null"
						:text=null
						@clicked="goBack()">
					</spot-button>
					<spot-button
						v-if="isVisibleButton(currField.canGoAhead)"
						fill="clear"
						size="large"
						color="primary"
						icon="chevronForwardCircleOutline"
						:enabled="!isDisableButton(currField.canGoAhead)"
						:expand="null"
						:text=null
						@clicked="goAhead()">
					</spot-button>
				</div>
			</div>
			<div id="debugArea" style="color:red;" v-if="settings.global.debug">
				<div>Test Area</div>
				Current Field: {{ currField }}<br>
				<div v-for="element in fields.list" :key="element.id">
					{{ element.name }} = {{ element.value }}
				</div>
			</div>
		</ion-content>
	</ion-page>
</template>

<style src="vue-multiselect/dist/vue-multiselect.css"></style> <!--<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>-->
<style scoped>
	ion-label {
		font-weight:bold;
	}
	.items-label {
		margin-top: .5em;
		margin-left: 1em;
	}
	.items-data {
		display: flex; /*inline-block;*/
		flex-direction: row;
		vertical-align: baseline;
		justify-content: space-between;
		text-align: left;
		margin-left: .5em;
		margin-right: .5em;
	}
</style>

<script>
	import { IonButton, IonContent, IonIcon, IonItem, IonLabel, IonPage, IonSpinner } from "@ionic/vue";
	import { chevronBackCircleOutline, chevronForwardCircleOutline, print, save } from "ionicons/icons";
	import { defineComponent } from "vue";
	import SpotButton from "../components/SpotButton.vue";
	import SpotHeader from "../components/SpotHeader.vue";
	import SpotSelect from "../components/SpotSelect.vue";
	import { checkUserSession, showMsgError, showMsgInfo, showMsgWarning } from "../plugins/common.js";
	import { settings } from "../plugins/settings.js";
	import { createProject, executePrinterAction, getPrinter, tablesData } from '../plugins/customDatabase.js';

	export default defineComponent({
		name: "InsertNew",
		props: {
			pageTitle: { type: String, default: "Inserisci nuova registrazione" },
			defaultSpinnerText: { type: String, default: "Caricamento..." },
			labelPrint: { type: String, default: "Stampa" },
			labelReprint: { type: String, default: "Ristampa" },
			labelSave: { type: String, default: "Salva" },
			labelAnd: { type: String, default: " e " },
			messageTitleInsert: { type: String, default: "Creazione Sovracollo" },
			messageTitlePrint: { type: String, default: "Stampa Etichetta" },
			successSaveMessage: { type: String, default: "Sovracollo creato" },
			successPrintMessage: { type: String, default: "Stampa sovracollo avvenuta correttamente. Etichetta: " },
			errorPrintMessage: { type: String, default: "Errore durante la stampa del sovracollo" },
			warningPrinterOffline: { type: String, default: "La stampante non è raggiungibile; l'etichetta non è stata stampata" },
			unselected: { type: String, default: "Nessuno" },
		},
		components: {
			IonPage,
			IonButton,
			IonSpinner,
			IonItem,
			IonIcon,
			IonContent,
			IonLabel,
			SpotHeader,
			SpotSelect,
			SpotButton,
		},
		data: () => ({
			isActive: null,
			isClosed: null,
			header_id: null,
			header_code: null,
			spinnerText: null,
			field: {
				movement_type: 0,
				movement_package: 1,
				movement_header: 2,
			},
			fields: {
				currentId: 0,
				list: [
					{ id: 0, name: 'movement_type', text: 'Tipo Movimento', allignLabel: false, placeholder: 'Seleziona Tipo Movimento', inputType: "combo", defaultValue: null, value: null, required: true, refField: 'text', canAddItem: false, canSkip: false, canGoBack: false, canGoAhead: true, canSave: false, canRefresh: false, canUnlock: false },
					{ id: 1, name: 'movement_package', text: 'Imballo', allignLabel: false, placeholder: 'Seleziona Imballo', inputType: "combo", defaultValue: null, value: null, required: true, refField: 'text', canAddItem: false, canSkip: false, canGoBack: true, canGoAhead: true, canSave: false, canRefresh: false, canUnlock: false },
					{ id: 2, name: 'movement_header', text: 'Salva e Stampa Sovracollo', allignLabel: false, placeholder: 'Salva e Stampa', inputType: "button", defaultValue: null, value: null, required: true/*false*/, canAddItem: false, canSkip: false, canGoBack: true, canGoAhead: true, canSave: false, canRefresh: false, canUnlock: false },
				],
			},
			privateData: {
				movement_types: [
					{ id: 0, name: 'Receipt', text: 'RICEZIONE', value: 'Receipt'},
					{ id: 1, name: 'Shipment', text: 'SPEDIZIONE', value: 'Shipment'},
				],
				movement_packages: [
					{ id: 0, name: 'PACC', text: 'PACCO SINGOLO', value: 'PACC'},
					{ id: 1, name: 'CASS', text: 'CASSA', value: 'CASS'},
					{ id: 2, name: 'BANC', text: 'BANCALE', value: 'BANC'},
				],
			},
			print,
			save,
			chevronBackCircleOutline,
			chevronForwardCircleOutline,
			settings,
			checkUserSession,
			showMsgInfo,
			showMsgWarning,
			showMsgError,
			createProject,
			executePrinterAction,
			getPrinter,
			tablesData,
		}),
		computed: {
			currField() {
				return this.fields.list[this.fields.currentId]
			},
			canPrint() {
				return (this.settings.global.printerManagement && this.tablesData.currentPrinter != null && this.fields.list[this.field.movement_package].value.id !== 0)
			}
		},
		async ionViewWillEnter() {
			await this.setDefault();
			this.isActive=true;
		},
		ionViewWillLeave() {
			document.activeElement?.blur();
			this.isActive=false;
		},
		watch: {
			currField() {
				if (this.settings.insert.autoSave && this.currField.id == this.field.movement_header) {
					this.saveRecord();
				}
			},
		},
		methods: {
			//Settings
			getPlaceHolder() {
				return ((this.settings.global.showFieldsPlaceholder) ? (this.currField.required ? this.currField.placeholder : this.unselected ) : '')
			},
			isDisableButton(ability) {
				if (this.settings.global.fieldsCheckOnButtons && ability) {
					return (this.currField.required && !this.currField.value) ? true : false
				}
				else {
					return !ability
				}
			},
			isVisibleButton(ability) {
				return (this.settings.global.hideUnneededButtons) ? ability : true
			},
			//Database
			prepareNewProject() {
				let myRecord = {
					project: {
						name: (this.fields.list[this.field.movement_package].value) ? this.fields.list[this.field.movement_package].value.value : null,
						receiving: (this.fields.list[this.field.movement_type].value.id == 0) ? true : false,
						shipping: (this.fields.list[this.field.movement_type].value.id == 1) ? true : false,
						warehouse_id: this.tablesData.currentWarehouse.id,
						plant_id: this.tablesData.currentPlant.id,
					}
				};
				return myRecord;
			},
			async saveRecord() {
				this.tablesData.currentProject = null;
				await this.createProject(this.prepareNewProject(), false);
				if (this.tablesData.currentProject) {
					this.header_id = this.tablesData.currentProject.id;
					this.header_code = this.tablesData.currentProject.code;
					this.currField.value = true;
					if (this.canPrint) {
						await this.getPrinter(this.tablesData.currentPrinter.id);
						if (this.tablesData.currentPrinter.is_online == true) {
							await this.executePrinterAction(`printers/` + this.tablesData.currentPrinter.id + `?do=print_single_barcode` + `&barcode=` + this.header_code + `&direction= ` + `&employee= ` + `&datetime=` + new Date().toLocaleString("it-IT"))
							.then(() => {
								this.showMsgInfo(this.messageTitleInsert, this.successSaveMessage + "<br><br>" + this.successPrintMessage + "&nbsp" + this.header_code);
								if (this.settings.insert.autoSave == true) this.goAhead();
							})
							.catch(error => {
								this.checkUserSession(error, "warning");
								this.showMsgError(this.messageTitlePrint, this.errorPrintMessage);
							})
						}
						else { 
							this.showMsgWarning(this.messageTitleInsert, this.successSaveMessage + "<br><br>" + this.warningPrinterOffline);
						}
					}
					else {
						this.showMsgInfo(this.messageTitleInsert, this.successSaveMessage);
						this.goAhead();
					}
				}
			},
			//Actions
			async setDefault() {
				this.spinnerText = this.defaultSpinnerText;
				this.fields.currentId = 0;
				this.fields.list.forEach(element => element.value = element.defaultValue);
				this.header_id = null;
				this.header_code = null;
			},
			detectSelection(value) {
				this.currField.value = value;
				if (this.settings.global.nextFieldOnComboSelect) setTimeout(() => this.goAhead(), 0);
			},
			detectUnselection() {
				this.currField.value = this.currField.defaultValue;
			},
			goBack() {
				if (this.fields.currentId > 0 ) this.fields.currentId-=1;
			},
			goAhead() {
				if (this.fields.currentId < (this.fields.list.length-1) ) this.fields.currentId+=1
				else this.executeLastFieldAction()
			},
			async createAndPrint() {
				if (!this.currField.value) {
					await this.saveRecord();
				}
				else {
					if (this.canPrint) {
						await this.getPrinter(this.tablesData.currentPrinter.id);
						if(this.tablesData.currentPrinter.is_online == true) {
							await this.executePrinterAction(`printers/` + this.tablesData.currentPrinter.id + `?do=print_single_barcode` + `&barcode=` + this.header_code + `&direction= ` + `&employee= ` + `&datetime=` + new Date().toLocaleString("it-IT"))
							.then(() => {
								this.showMsgInfo(this.messageTitlePrint,this.successPrintMessage + "&nbsp" + this.header_code);
							})
							.catch(error => {
								this.checkUserSession(error, "warning");
								this.showMsgError(this.messageTitlePrint, this.errorPrintMessage);
							})
						}
						else {
							this.showMsgWarning(this.messageTitlePrint,this.warningPrinterOffline);
						}
					}
				}
			},
			executeLastFieldAction() {
				if (this.settings.global.fieldsCheckOnButtons == true) {
					let multi = (this.fields.list[this.field.movement_package].value.id !== 0) ? true : false
					switch (this.fields.list[this.field.movement_type].value.value) {
						case 'Receipt':
							this.$router.push(`/insert/receipt?header_id=` + this.header_id + `&multiple=` + multi);
							break;
						case 'Shipment':
							this.$router.push(`/insert/shipment?header_id=` + this.header_id + `&multiple=` + multi);
							break;
						default:
							//TODO: aggiungi checkUserSession (ma non dovrebbe mai arrivarci)
					}
				}
			},
		},
	});
</script>